import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';

import { onClose } from '~/common/closeMessage';
import { useStyle } from '~/common/style';

import { getSDK } from '~/states/modules/sdk';
import { getCompany } from '~/states/modules/company';
import { getConsent } from '~/states/modules/consent';
import { getCookies } from '~/states/modules/cookies';

const Template = ({ children }) => {
	const dispatch = useDispatch();
	const company = useSelector(({ company }) => company.data);
	const sdk = useSelector(({ sdk }) => sdk.data);
	const [consentId, setConsentId] = useState(null);
	const custom = useStyle();
	const domain = useMemo(
		() => window.location.pathname.split('/')[1] || '',
		[],
	);

	const listener = (message) => {
		try {
			const { type, data } = JSON.parse(message.data);
			if (type === 'SET_NEW_UUID') setConsentId(data);
		} catch (e) {
			// ignore the error!
			// console.warn('Failed to parse message: ', message.data);
			// console.warn('Failed to listen!', e);
		}
	};

	useEffect(() => {
		window.addEventListener('message', listener);
		return () => {
			window.removeEventListener('message', listener);
		};
	}, []);

	useEffect(() => {
		dispatch(getCompany(domain));
		dispatch(getSDK(domain));
	}, [dispatch, domain]);

	useEffect(() => {
		if (company) {
			if (consentId) dispatch(getConsent({ consentId, companyId: company.id }));
			dispatch(getCookies(company.id));
		}
	}, [dispatch, company, consentId]);

	return (
		<div className="App" id="DLapp">
			{company ? (
				<div className="container">
					<div className="row">
						<div className="col-sm-12 pl-0 pr-0">
							<div className="card">
								<div
									className="card-header container-fluid border-bottom-0"
									style={{
										backgroundColor: custom.cookiebarBgColor,
										color: custom.cookiebarTxtColor,
									}}
								>
									<div className="row">
										<div className="col d-flex justify-content-between">
											<h5 className="w-8 mb-0 fs-title">
												Controle sua privacidade
											</h5>
											<button
												type="button"
												className="close"
												aria-label="Close"
												onClick={onClose}
											>
												<span
													aria-hidden="true"
													style={{
														color: custom.cookiebarTxtColor,
													}}
												>
													&times;
												</span>
											</button>
										</div>
									</div>
								</div>
								<div
									className="card-body container-fluid mt-0 pt-0"
									style={{
										backgroundColor: custom.cookiebarBgColor,
										color: custom.cookiebarTxtColor,
									}}
								>
									<div
										className="row"
										style={{ height: '100px', overflow: 'auto' }}
									>
										<div
											className="col fs-text"
											dangerouslySetInnerHTML={{
												__html: custom.cookiebarDescription,
											}}
										></div>
									</div>
									<div className="row">
										<div
											className="col d-flex justify-content-around fs-link w-7"
											style={{
												color: custom.cookiebarLinkColor,
											}}
										>
											{/* <span>•</span> */}
											<a
												href={company?.privacy || '#'}
												style={{
													color: custom.cookiebarLinkColor,
												}}
												target="_blank"
												rel="noreferrer"
												dangerouslySetInnerHTML={{
													__html:
														sdk?.cookiebarLinkTxt || 'Política de Privacidade',
												}}
											/>
											{/* <span>•</span>
											<a
												href={company?.url || '#'}
												style={{
												color: custom.cookiebarLinkColor || theme.linkColor,
											}}										>
												Termos de Uso
											</a>
											<span>•</span>
											<span>•</span>
											<a
												href="#"
												style={{
												color: custom.cookiebarLinkColor || theme.linkColor,
												}}
											>
													Opt-Out
											</a> */}
										</div>
									</div>
									<br />
									<div className="row">{children}</div>
								</div>
								<div className="card-footer border-top-0 p-3 fs-text">
									<p className="text-center mb-0">
										Powered by{' '}
										<a
											href="https://www.nimbusprivacy.com.br"
											style={{
												color: custom.cookiebarBtnColor,
											}}
											target="_blank"
											rel="noreferrer"
										>
											Nimbus Privacy
										</a>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className="container">
					<div className="row">
						<div className="col-sm-12 m-0 p-0">
							<div className="card d-flex justify-content-center m-0">
								<ReactLoading
									className="col-12  d-flex justify-content-center"
									type={'bubbles'}
									style={{
										width: '350px',
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

Template.propTypes = {
	children: PropTypes.node.isRequired,
	text: PropTypes.string,
};

export default Template;
